import { Component, inject, signal, computed, input, output, effect } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { InputText } from 'primeng/inputtext';
import { Password } from 'primeng/password';
import { Dialog } from 'primeng/dialog';
import { Toast } from 'primeng/toast';
import { MessageService, PrimeTemplate } from 'primeng/api';
import { AuthService } from '../../core/services/api/auth.service';
import { UserService } from '../../core/services/api/entity.service';

@Component({
    selector: 'app-profile',
    standalone: true,
        imports: [PrimeTemplate, CommonModule, ReactiveFormsModule, InputText, Password, Dialog, Toast],
    providers:
 [MessageService],
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.scss']
})
export class ProfileComponent {
    private auth = inject(AuthService);
    private svc = inject(UserService);
    private fb = inject(FormBuilder);
    private toast = inject(MessageService);

    visible = input(false);
    close = output<void>();

    saving = signal(false);

    user = computed(() => this.auth.user());

    form = this.fb.group({
        fullName: ['', [Validators.required, Validators.maxLength(200)]],
        phone: ['', Validators.maxLength(30)],
        currentPassword: [''],
        newPassword: ['', [Validators.minLength(6)]]
    });

    constructor() {
        effect(() => {
            if (this.visible()) {
                const u = this.user();
                this.form.patchValue({
                    fullName: u?.fullName ?? '',
                    phone: u?.phone ?? '',
                    currentPassword: '',
                    newPassword: ''
                });
            }
        });
    }

    save(): void {
        if (this.form.invalid) {
            this.form.markAllAsTouched();
            return;
        }

        const { currentPassword, newPassword } = this.form.value;

        if (newPassword && !currentPassword) {
            this.toast.add({ severity: 'error', summary: 'Debe ingresar su contraseña actual para cambiarla' });
            return;
        }

        this.saving.set(true);

        const payload: any = {};
        if (this.form.value.fullName) payload.fullName = this.form.value.fullName;
        if (this.form.value.phone !== undefined) payload.phone = this.form.value.phone;
        if (newPassword) {
            payload.currentPassword = currentPassword;
            payload.newPassword = newPassword;
        }

        this.svc.updateProfile(payload).subscribe({
            next: (res) => {
                this.auth.updateUser({ fullName: res.fullName, phone: res.phone });
                this.toast.add({ severity: 'success', summary: 'Perfil actualizado correctamente' });
                this.form.patchValue({ currentPassword: '', newPassword: '' });
                this.saving.set(false);
            },
            error: (err) => {
                this.toast.add({ severity: 'error', summary: err?.error?.message ?? 'Error al actualizar perfil' });
                this.saving.set(false);
            }
        });
    }

    onHide(): void {
        this.close.emit();
    }

    hasError(f: string, v: string): boolean {
        const c = this.form.get(f);
        return !!(c?.touched && c?.hasError(v));
    }
}
